import { render, staticRenderFns } from "./EconomyTab.vue?vue&type=template&id=0ff48dd7&"
import script from "./EconomyTab.vue?vue&type=script&lang=js&"
export * from "./EconomyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports